import { useEffect, useRef, useState } from 'react'

/**
 * Scales a fixed-size design (e.g. a 1080x1080 ad creative) down to the
 * width of its responsive wrapper, keeping pixel-perfect internal proportions.
 */
export function useScaleToFit(designSize: number) {
  const ref = useRef<HTMLDivElement>(null)
  const [scale, setScale] = useState(1)

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const update = () => setScale(element.clientWidth / designSize)
    update()

    const observer = new ResizeObserver(update)
    observer.observe(element)
    return () => observer.disconnect()
  }, [designSize])

  return { ref, scale }
}
